import React, { useState, useEffect } from 'react'
import { history, setLocale, useDispatch, useModel } from 'umi'
import { getQiankunApps } from './utils/qiankunRouter'
// import { initBaiduTongji } from './utils/tongji'
import onStorage, {
  setStorage,
  removeStorage,
  getStorage,
} from '@/libs/functions/onStorage'
import { loadBankJS, loadWXJS, loadDDJS } from '@/utils/loadJS'
import { getUrlParam } from './libs/functions/getValue'
const _ = require('lodash')
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { Reducer, StoreEnhancer } from 'redux'
import { initLang } from './utils/lang'
import {
  getLocaleByPriority,
  setWindowLang,
  transLangKeysForBoss,
} from '@/libs/functions/lang'

import initUnifiedTracker, {
  setCommonParams,
  trackUserLogout,
} from './utils/dpTracker'
import { trackMasterFrameworkSuccess, trackPageView } from './utils/track'
import { routeChangeHook } from './utils/bankJs'
import AiChatbotBubble from './components/AiChatbotBubble'
import { reportShareToMiniProgram } from './utils/miniProgram'

const persistEnhancer: StoreEnhancer =
  (next) => (reducer: Reducer<any, any>) => {
    const store = next(
      persistReducer(
        {
          key: 'main',
          storage,
        },
        reducer,
      ),
    )
    const persist = persistStore(store)
    return { ...store, persist }
  }

export const dva = {
  config: {
    extraEnhancers: [persistEnhancer],
  },
}

export function rootContainer(container: React.ReactNode) {
  return React.createElement(
    React.Fragment,
    null,
    container,
    React.createElement(AiChatbotBubble),
  )
}

// 设置window的方法
;(window as any).setWindow = (key: string, data: any) => {
  ;(window as any)[key] = data /*  */
}
;(window as any).getWindow = (key: string) => {
  return (window as any)[key]
}

// 注入百度统计
// initBaiduTongji()

// 注入银行api
loadBankJS()

// 注入微信SDK
const wxSdkReady = loadWXJS()

// 注入钉钉SDK
loadDDJS()

// try {
//   if (!isStorageAvailable('local', 'app_lang')) {
//     throw new Error('localStorage is disabled or full')
//   }
//   // 注入多语言
//   initLang()
// } catch (error: any) {
//   onStorageError(error, 'app_lang')
// }

// 注入多语言
// 同步设置 window.lang，确保子应用模块评估时可以访问
const { locale } = getLocaleByPriority()
setWindowLang(transLangKeysForBoss(locale))

// 完整初始化（语料拉取、umi setLocale）延迟到空闲时执行
if (window.requestIdleCallback) {
  window.requestIdleCallback(() => {
    initLang()
  })
} else {
  initLang()
}

;(async function () {
  // 注入前端统一SDK
  await initUnifiedTracker()
})()

// 全局方法
window.masterHistory = history

trackMasterFrameworkSuccess()

const isProdEnv = process.env.NODE_ENV === 'production'

// 注册子应用
export const qiankun = () => {
  return {
    apps: getQiankunApps(),
    // 预加载子应用 【goods】【verification】
    // prefetch: isProdEnv ? ['equity', 'goods', 'verification'] : [],
    // 预加载应用阈值
    prefetchThreshold: 0,
    lifeCycles: {
      beforeLoad: async (props) => {
        window.__QIANKUN_APP_NAME__ = props.name
        // initSensor()
        // initUnifiedTracker()
      },
      beforeMount: () => {
        const channel = getUrlParam('channel')
        const hideWebviewNavBar = getUrlParam('hideWebviewNavBar')
        const storageTenantCode = getStorage('tenantCode')
        const tenantCode = getUrlParam('tenantCode')
        const openId = getUrlParam('openId') || ''

        // 用于埋点 关联用户
        if (openId) {
          setStorage('openId', openId)
        }
        if (channel) {
          setStorage('channel', channel)
        }
        if (tenantCode) {
          setStorage('tenantCode', tenantCode)
          if (storageTenantCode !== tenantCode) {
            trackUserLogout()
            removeStorage('h5Token')
          }
        }
        setCommonParams()
        // > 控制Layout组件头部导航栏是否显示
        if (hideWebviewNavBar) {
          setStorage('hideWebviewNavBar', hideWebviewNavBar)
        }
      },
      afterMount: (props: any) => {
        // console.log('qiankun这里是啊晒晒撒谎萨哈---', props)
      },
      afterUnmount: (props: any) => {},
    },
  }
}

// 微前端默认modeal数据
export function useQiankunStateForSlave() {
  const cacheKey = 'qiankunGlobalState'
  const globalStateCache = onStorage.getItem(cacheKey) || {}
  let defaultState = _.assign(
    {},
    {
      masterHistory: history,
      discount: {}, // 当前选择的优惠券
      equity: {}, // 当前选择权益
      categorySettingState: {
        GLOBAL: null,
        DG: null,
        SL: null,
        FT: null,
        GC: null,
        LCG: null,
        MG: null,
        LS: null,
        GV: null,
        JD: null,
        JDRetail: null,
        TPS: null,
        SC: null,
        COMMON_SERVICE_COMMODITY: null,
        COMMON_SERVICE_GTWM: null,
      },
      channel: onStorage.getItem('channel') || '', // 渠道 changan
    },
    globalStateCache,
  )
  const [qiankunGlobalState, setQiankunGlobalState] =
    useState<any>(defaultState)
  window.qiankunGlobalState = qiankunGlobalState
  return {
    qiankunGlobalState,
    setQiankunGlobalState: (data: any) => {
      const state = _.assign({}, defaultState, data)
      onStorage.setItem(cacheKey, state)
      defaultState = state
      setQiankunGlobalState(state)
    },
  }
}

// 初始化信息处理
export async function getInitialState() {
  const channel = getUrlParam('channel')
  const storageTenantCode = getStorage('tenantCode')
  const tenantCode = getUrlParam('tenantCode')
  const openId = getUrlParam('openId') || ''
  // 用于埋点 关联用户
  if (openId) {
    setStorage('openId', openId)
  }
  if (channel) {
    setStorage('channel', channel)
  }
  if (tenantCode) {
    setStorage('tenantCode', tenantCode)
    if (storageTenantCode !== tenantCode) {
      trackUserLogout()
      removeStorage('h5Token')
    }
  }
  setCommonParams()

  const hideWebviewNavBar = getUrlParam('hideWebviewNavBar')
  // > 控制Layout组件头部导航栏是否显示
  if (hideWebviewNavBar) {
    setStorage('hideWebviewNavBar', hideWebviewNavBar)
  }
  const data = {
    name: 'test',
  }
  return data
}

// 监听
let isFirstMount = true

export function onRouteChange({ location }) {
  const channel = getUrlParam('channel')
  const lang = getUrlParam('lg') || ''
  // initSensor()
  initUnifiedTracker()
  // 支付结果页 - 【回到首页】个人中心，回到 h5代下单服务页
  const isBackDkHomePage = getUrlParam('isBackDkHomePage') || ''
  const hideWebviewNavBar = getUrlParam('hideWebviewNavBar')

  if (channel && channel !== getStorage('channel')) {
    setStorage('channel', channel)
  }

  if (isBackDkHomePage === '1') {
    setStorage('isBackDkHomePage', true)
  } else if (isBackDkHomePage && isBackDkHomePage !== '1') {
    removeStorage('isBackDkHomePage')
  }

  routeChangeHook()

  // > 控制Layout组件头部导航栏是否显示
  if (hideWebviewNavBar && hideWebviewNavBar === '1') {
    setStorage('hideWebviewNavBar', hideWebviewNavBar)
  } else if (hideWebviewNavBar && hideWebviewNavBar !== '1') {
    removeStorage('hideWebviewNavBar')
  }

  if (lang) {
    setLocale(lang)
  }
  // page onload 会额外触发多一次
  if (isFirstMount) {
    isFirstMount = false
    return
  }

  reportShareToMiniProgram(wxSdkReady, location)

  const env = process.env.UMI_ENV
  if (
    process.env.NODE_ENV === 'production' &&
    (env === 'prod' || env === 'ali-uat' || env === 'test')
  ) {
    // 正式的业务逻辑 console.log('PV: ')
    trackPageView(location)
  } else {
    trackPageView(location)
  }
}
